export enum HookPlatforms {
  ALL = 'ALL',
  MOBILE = 'MOBILE',
  WEB = 'WEB',
}